import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { GetProfileDetailsRequest } from '../api/myaccount/getprofiledetails/getprofiledetailsrequest';
import { GetProfileDetailsResponse, GetProfileDetailsResponseDtoImpl } from '../api/myaccount/getprofiledetails/getprofiledetailsresponse';
import { GetProfileDetailsBuilder } from '../dto/getprofile/getprofiledetailsbuilder';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class GetProfileDetailsAPIProcessorImpl extends SixdeeCRBTAPIProcessor<GetProfileDetailsRequest, GetProfileDetailsResponse>
{
    private LOGGER: Logger = LogManager.getLogger(GetProfileDetailsAPIProcessorImpl.name);
    execute(request: GetProfileDetailsRequest): void {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void {
        this.LOGGER.log("onSuccess() invoked");
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetProfileDetailsResponseDtoImpl(APIFeatures.GET_PROFILE_DETAILS, "Get Profile Details Success");

                response.setProfileDetailsDto(new GetProfileDetailsBuilder(responseMapper.getResponseMap().getProfileDetails).buildAll());

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetProfileDetailsResponseDtoImpl(APIFeatures.GET_PROFILE_DETAILS, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetProfileDetailsResponseDtoImpl(APIFeatures.GET_PROFILE_DETAILS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            console.log(e);
            this.getAPIFailure(new GetProfileDetailsResponseDtoImpl(APIFeatures.GET_PROFILE_DETAILS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        
        console.log("yellowfailr");
            this.getAPIFailure(new GetProfileDetailsResponseDtoImpl(APIFeatures.GET_PROFILE_DETAILS, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getprofiledetailsapiprocessor.tsx